import { observer } from 'mobx-react-lite';
import React from 'react';
import BusinessActivityPlus from './BusinessActivityPlus';
import BusinessActivityPrime from './BusinessActivityPrime';
import { V2_TYPE } from './helperV2';

const BusinessActivityV2 = (props) => {
    if (Number(props?.applicationForm?.type) === V2_TYPE.PLUS) {
        return <BusinessActivityPlus {...props} />;
    }

    return <BusinessActivityPrime {...props} />;
};

export default observer(BusinessActivityV2);
